import React from 'react';
import PropTypes from 'prop-types';
import StackDecisions from '../components/new-decisions';
import {GridItem} from '../components/shared/render';
import NavAnchor from '../components/shared/nav-anchor';
import SignUpPrivateStackshare from '../../../shared/library/advert/sign-up-private-stackshare';
import {NAVBAR_HEIGHT} from '../../../shared/style/dimensions';

const NAV_BAR_HEIGHT = 90;
const TOOL_CARD_STICKY_HEIGHT = 72;
const NAV_ANCHOR_OFFSET = NAV_BAR_HEIGHT + TOOL_CARD_STICKY_HEIGHT + NAVBAR_HEIGHT + 20;

const Decisions = ({num, stackup, privateMode, tools, slug, stackupForPackages}) => {
  return (
    <>
      <NavAnchor id="decisions" offset={NAV_ANCHOR_OFFSET} span={num} />

      {stackup &&
        stackup.privateStackDecisionsGetAdvice &&
        stackup.privateStackDecisionsGetAdvice.edges.length > 0 &&
        privateMode && (
          <GridItem span={num} style={{borderBottom: 'none', paddingBottom: 0}}>
            <StackDecisions
              tools={tools}
              items={stackup.privateStackDecisionsGetAdvice}
              slug={slug}
              isAdvice={true}
              isPrivate={true}
            />
          </GridItem>
        )}

      {stackup &&
        stackup.cachedStackDecisionsGetAdvice &&
        stackup.cachedStackDecisionsGetAdvice.edges.length > 0 && (
          <GridItem span={num} style={{borderBottom: 'none', paddingBottom: 0}}>
            <StackDecisions
              tools={tools}
              items={stackup.cachedStackDecisionsGetAdvice}
              slug={slug}
              isAdvice={true}
            />
          </GridItem>
        )}

      {stackup &&
        stackup.privateStackDecisions &&
        stackup.privateStackDecisions.edges.length > 0 &&
        privateMode && (
          <GridItem span={num} style={{borderBottom: 'none', paddingBottom: 0}}>
            <StackDecisions
              companyName={privateMode && privateMode.name}
              tools={tools}
              items={stackup.privateStackDecisions}
              isPrivate={true}
            />
          </GridItem>
        )}

      {stackup && stackup.cachedStackDecisions && stackup.cachedStackDecisions.edges.length > 0 && (
        <GridItem span={num} style={{borderBottom: 'none', paddingBottom: 0}}>
          <StackDecisions tools={tools} items={stackup.cachedStackDecisions} slug={slug} />
        </GridItem>
      )}

      {!privateMode && !stackupForPackages && (
        <GridItem span={num}>
          <SignUpPrivateStackshare
            banner
            title="Manage your open source components, licenses, and vulnerabilities"
            extraStyle={{paddingTop: 0, paddingBottom: 0}}
          />
        </GridItem>
      )}
    </>
  );
};

Decisions.propTypes = {
  num: PropTypes.number,
  slug: PropTypes.string,
  stackup: PropTypes.object,
  tools: PropTypes.array,
  privateMode: PropTypes.any,
  stackupForPackages: PropTypes.bool
};

export default Decisions;
